// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.production.ts`.
// The list of file replacements can be found in `angular.json`.

import { modules } from '@env/modules';

export const environment = {
  production: false,
  envName: 'DEV',
  api: modules,
};
